import React from 'react';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconDropdown from 'components/IconDropdown';
import styled from 'styled-components';
import { NewStyledIconButton, StyledTypography, VerticallyAlignedFlexContainer } from 'styles/common';

import { ThreeDots } from 'assets/assetsV1/iconComponents';

import { StyledIcon, VisibilityIcon } from 'constants/icons';

export const ThreeDotsIcon = ({ className, isDisabled }) => (
  <NewStyledIconButton className={className} disabled={isDisabled}>
    <StyledIcon color="#bcbcbc" size="tiny">
      <MoreVertIcon />
    </StyledIcon>
  </NewStyledIconButton>
);

function VisibilityDisplay({ visibilityType }) {
  return (
    <VerticallyAlignedFlexContainer>
      <StyledTypography color="textSecondary" variant="caption" rightGutter={0.5}>
        {visibilityType.displayName}
      </StyledTypography>
      <VisibilityIcon visibility={visibilityType.name} size="tinier" color="textSecondary" />
    </VerticallyAlignedFlexContainer>
  );
}

// need to use the commented out code, that's modular approach
export default function DotsMoreComponent({ className, menuItems, iconComponent, isDisabled = false }) {
  // const menuId = generateKey(5);
  return (
    // <CustomMenu icon={iconComponent || <ThreeDotsIcon />}>
    //   <CustomMenu.DropdownList>
    //     {menuItems.map((item, i) => (
    //       <Tooltip title={item.disabledReason}>
    //         <StyledMenuItem
    //           dense={item.dense || false}
    //           disabled={item.disabled}
    //           separator={true}
    //           onClick={item.onClick}
    //           key={`${menuId}-item-${i}`}
    //         >
    //           {item.content}
    //         </StyledMenuItem>
    //       </Tooltip>
    //     ))}
    //   </CustomMenu.DropdownList>
    // </CustomMenu>
    <StyledIconDropdown
      className={className}
      displayArrow={false}
      isDisabled={isDisabled}
      icon={iconComponent || <ThreeDots boxSize="24px" color="text.g2" />}
      menuItems={menuItems}
    />
  );
}

export const getCommentsMoreMenuItems = ({
  toggleEditing,
  isEditable,
  cantEditReason,
  visibilityType,
  onlyEditingAllowed = false,
}) => {
  if (onlyEditingAllowed) {
    return [
      {
        content: 'Edit',
        onClick: toggleEditing,
        contentProps: { variant: 'caption', color: 'textSecondary' },
        disabled: !isEditable,
        disabledReason: cantEditReason || '',
        dense: true,
      },
    ];
  }
  return [
    {
      content: 'Edit',
      onClick: toggleEditing,
      contentProps: { variant: 'caption', color: 'textSecondary' },
      disabled: !isEditable,
      disabledReason: cantEditReason || '',
      dense: true,
    },
    {
      content: <VisibilityDisplay visibilityType={visibilityType} />,
      onClick: null,
      contentProps: { variant: 'caption', color: 'textSecondary' },
      dense: true,
    },
  ];
};

export const getPostMoreMenuItems = ({ toggleEditing, isEditable, cantEditReason, visibilityType = null }) => {
  const items = [
    {
      content: 'Edit',
      onClick: toggleEditing,
      contentProps: { variant: 'caption', color: 'textSecondary' },
      disabled: !isEditable,
      disabledReason: cantEditReason || '',
      dense: true,
    },
  ];

  return visibilityType
    ? [
        ...items,
        {
          content: <VisibilityDisplay visibilityType={visibilityType} />,
          onClick: null,
          contentProps: { variant: 'caption', color: 'textSecondary' },
          dense: true,
        },
      ]
    : items;
};

const StyledIconDropdown = styled(IconDropdown)`
  z-index: 1500;
`;
